import Typography from "@material-ui/core/Typography";
import styled from "styled-components";

export default styled(Typography)`
	color: ${(props) => props.theme.sidebar.color};
	padding: ${(props) => props.theme.spacing(4)}px ${(props) => props.theme.spacing(6)}px ${(props) => props.theme.spacing(1)}px;
	opacity: 0.9;
	display: block;
`;
